import React from 'react'

// import '@/pages/dashboard/assets/css/components/dbMetrics.css';
// import SvgIcon from '@/pages/dashboard/components/Iconfont';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Icon } from "tea-component";

type UpAndDownDataType = {
  data: number | string
  status: 'up' | 'down' | 'zero' | 'no'
}

interface UpAndDownProps {
  data: number | string
  status: 'up' | 'down' | 'zero' | 'no'
  isShow?: boolean;
  className?: string
  style?: React.CSSProperties
}

/**
 *  正常状态 涨跌百分比和箭头都存在
 *  涨跌为0%, 箭头显示 -, 颜色为灰色
 *  涨跌无数据, 整体显示 -
 * @param data
 * @param status
 * @param isShow
 * @param className
 * @param style
 * @constructor
 */
function UpAndDown({ data, status = 'up', isShow = true, className, style }: UpAndDownProps) {
  const svgTypeObj = {
    up:'green-up-new',
    down:'red-down-new'
  }
  if (data == "-" && status !== "no") status = "zero"; // 内部判断后, 外界只需要传递up或down
  return (<span
    className={`${status === 'up' ? 'text-green db-metrics--status-up' : status === 'down' ? 'text-red db-metrics--status-down' : 'db-metrics--status-zero'} ${className ? ` ${className}`:''}`}
    style={style}
  >

    {
      status !== "no" ? (<>
        {data}
        {
          data !== "-" ? (
            <>
            {/* 'bottom-green':'top-red' */}
              {
                (status === "zero") ? " -" : <SvgIcon
                  type={svgTypeObj[status]}
                />
              }
            </>

          ) : ""
        }
      </>) : ""
    }

  </span>)
}

export { UpAndDownProps, UpAndDownDataType }
export default UpAndDown
